export const WELCOME_PAGE_CONTAINER_ID = 'welcome-page-welcome-container';
export const ABOUT_US_PAGE_CONTAINER_ID = 'welcome-page-about-us-page-container';
export const MAIN_CONTAINER_ID = 'welcome-page-main-container';
export const JOBS_PAGE_CONTAINER_ID = 'jobs-page-container';
export const FORM_PAGE_CONTAINER_ID = 'form-page-container';
export const WELCOME_PAGE_VIDEO_ID = 'welcome-page-video';

export const UPLOAD_MIME_TYPES = [
  'application/msword', // Microsoft Word [.doc]
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Microsoft Word (OpenXML) | .docx
  'image/gif', // Graphics Interchange Format (GIF) [.gif]
  'image/jpeg', // JPEG images [.jpeg, .jpg]
  'image/png', // Portable Network Graphics [.png]
  'application/pdf', // Adobe Portable Document Format (PDF) [.pdf]
  'image/svg+xml', // Scalable Vector Graphics (SVG) [.svg]
  'text/plain', // Text, (generally ASCII or ISO 8859-n) [.txt]
  'image/webp', // WEBP image [.webp]
  'application/vnd.ms-excel', // Microsoft Excel [.xls]
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Microsoft Excel (OpenXML) [.xlsx]
  'application/vnd.oasis.opendocument.text', // OpenDocument Text [.odt]
];
